export default "/images/vendor/flag-icon-css/flags/4x3/hk.svg?c0a93c089256c99bf337965d0074738d";